import { ContractGuard } from './contract.guard';

export const guards: any[] = [ContractGuard];

export * from './contract.guard';
